// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__3Mbmx","info":"footer_info__2j_Nk","link":"footer_link__rNuqK"};